// setCurrentAutoplayPostId.js
'use strict';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';

/**
 * Set the post ID in the Following that should autoplay
 * @kind action
 * @param {string} {postId} - the ID of the post that currently active and should autoplay.
 * @return {Promise} Action promise.
 */
const setCurrentAutoplayPostId = postId => async dispatch => {
  return dispatch({
    type: MERGE_OPERATION_DATA,
    payload: {
      selectPath: ['feed'],
      data: {
        currentAutoplayPostId: postId,
      },
    },
  });
};

export default setCurrentAutoplayPostId;
